import FeatureBox from "./featureBox";
import PhoneImage from "../../../assets/images/png/corporatePhone.png";

import "./index.scss";

const FeaturesOverview = () => (
  <div className="features-overview">
    <h3 className="features-main-heading">Features Overview</h3>
    <p className="feature-text">
      Each employee will give access to the following features included in the app, as well as add-ons that are
      available to each of them at discounts.
    </p>
    <div className="features-content">
      <div className="features-left">
        <img className="feature-image" src={PhoneImage} alt="feature image" />
      </div>
      <div className="features-middle">
        <FeatureBox
          heading="Workouts Designed based on YOUR goals"
          featureDetails="Workouts will be built towards the goals of the employee, based on what they have available to them, updated each month and pushed directly to the app. Videos and descriptions included. "
        />
        <FeatureBox
          heading="Activity Tracker"
          featureDetails="Sync your app with apple health kit & google fit, tracking all available health makers in one place."
        />
        <FeatureBox
          heading="Nutrition Guidance"
          featureDetails="Use our macro calculator to better understand how many calories you should be eating based on your goals, breaking down your nutrition by recommended amounts of protein, carbs and fats."
        />
        <FeatureBox
          heading="Track Progress"
          featureDetails="Record measurements of pre-selected areas, take progress photos, and compare your results to previous dates to help you see how far you've come!"
        />
      </div>
      <div className="features-right">
        <FeatureBox
          heading="Message your trainer"
          featureDetails="Have questions about your workouts or nutrition? Shoot your trainer a messae in an instant"
        />
        <FeatureBox
          heading="Daily Trivia"
          featureDetails="Education is a huge part of a successful wellness program. Answer daily trivia questions to not only further educate yourself along your journey, but to earn points and climb the leaderboard for monthly giveaways."
        />
        <FeatureBox
          heading="Leaderboard"
          featureDetails="Our one-of-a-kind leaderboard rewards employees for the steps taken towards reaching their goals rather than just the final product. Earn omni-coins for completing workouts, answering trivia questions, and achieving other daily goals, entering you to win giveaways each month."
        />
        <FeatureBox
          heading="Additional Services"
          featureDetails="Our one-on-one personal training services can be made available both in-person and virtually within the app at a discounted price, allowing for even more personalization for those seeking a more hands on approach."
        />
      </div>
    </div>
  </div>
);

export default FeaturesOverview;
